<template>
  <div id="app" v-cloak >
    <!-- <HeaderTop></HeaderTop>
    
    <div class="main-bg">
      <div class="main" v-anchor>
        <router-view class="router-view" />
        <Footer></Footer>
      </div>
    </div> -->
		<router-view></router-view>
  </div>
</template>
<script>
// import HeaderTop from "@/components/HeaderTop.vue";
// import Footer from "@/components/Footer.vue";
export default {
  name: "App",
  components: {
    // Footer,
    // HeaderTop
  },
};
</script>
<style scoped lang="scss">
#app {
  color: #1a1a1a;
}

.main-bg {
  background: #F3F3F3;

  .router-view {
    padding-top: 24px;
    margin-bottom: 20px;
  }

  .main {
    margin: auto;
    width: 1200px;
    padding-bottom: 20px;
  }
}

</style>
